import { ref, computed, watch } from "vue";
import { useMyForm } from "~/lib/myVeeValidate";
import cloneDeep from "lodash/cloneDeep";
import initServiceModalFeature, {
  modalProps as serviceModalProps,
  modalEmits as serviceModalEmits,
} from "~/composables/service-modal";
import { useMyField } from "~/lib/myVeeValidate";
import { syncData } from "~/utils/miscellaneous";

export const modalProps = {
  ...serviceModalProps,
  type: {
    type: String,
  },
};

export const modalEmits = {
  ...serviceModalEmits,
};

export default function initModalFeature({
  props,
  emit,
  formValidationSchema,
  onSubmitConfig,
  syncFields,
}) {
  const data = ref(null);

  watch(
    () => props.modelValue,
    (val) => (data.value = cloneDeep(val)),
    { deep: true, immediate: true }
  );

  const {
    dialog,
    graphql,
    dataloader,
    isLoading,
    serviceConfirmationData,
    hasError,
    submitClicked: serviceSubmitClicked,
  } = initServiceModalFeature(
    { props, emit, onSubmitConfig },
    {
      serviceConfigArgs: [data],
      dataloaderConfigArgs: [data],
      serviceMethodInitArgs: [data],
    }
  );

  const { meta, errors, validate, resetFields } = formValidationSchema
    ? useMyForm({
        validationSchema: formValidationSchema,
      })
    : {};

  const isFormValid = computed(
    () =>
      formValidationSchema &&
      (meta.value.valid || Object.keys(errors.value).length == 0)
  );

  const disableSubmit = computed(
    () =>
      (formValidationSchema && (!isFormValid.value || !meta.value.dirty)) ||
      isLoading.value
  );

  if (syncFields) {
    Object.entries(syncFields).forEach(([key, val]) => {
      const { value } = useMyField(key);

      setTimeout(() => {
        resetFields({
          [key]: {
            value: val.value,
          },
        });
      });

      syncData(val, value);
    });
  }

  async function submitClicked() {
    if (formValidationSchema) {
      let res = await validate();

      if (!res.valid) return;
    }

    return await serviceSubmitClicked();
  }

  return {
    dialog,
    data,
    graphql,
    dataloader,
    isLoading,
    serviceConfirmationData,
    hasError,
    disableSubmit,
    submitClicked,
    resetFields,
  };
}
